import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import { Card, CardContent } from '@/components/ui/card';
import { Mail, Phone, MapPin } from 'lucide-react';
import contactHero from '@/assets/contact-hero.jpg';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-brand-darkBlack">
      <div className="star-field"></div>
      
      {/* Hero Section with Image */}
      <div className="relative overflow-hidden">
        <img 
          src={contactHero} 
          alt="Kontakt oss" 
          className="w-full h-auto object-contain"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-darkBlack via-brand-darkBlack/50 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="container mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold text-brand-gold font-orbit mb-4">
              Kontakt oss
            </h1>
            <p className="text-xl text-white/80 max-w-2xl">
              Vi er her for å hjelpe deg. Ta kontakt med oss for spørsmål om produkter, bestillinger eller samarbeid.
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <Breadcrumbs />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          <Card className="bg-brand-charcoal/90 border-brand-gold/30">
            <CardContent className="p-6 flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-full bg-brand-gold/20 flex items-center justify-center mb-4">
                <Mail className="w-8 h-8 text-brand-gold" />
              </div>
              <h3 className="text-xl font-bold text-brand-gold mb-2">E-post</h3>
              <a 
                href="mailto:kundeservice@peveo.no" 
                className="text-white hover:text-brand-lightGold transition-colors"
              >
                kundeservice@peveo.no
              </a>
            </CardContent>
          </Card>

          <Card className="bg-brand-charcoal/90 border-brand-gold/30">
            <CardContent className="p-6 flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-full bg-brand-gold/20 flex items-center justify-center mb-4">
                <Phone className="w-8 h-8 text-brand-gold" />
              </div>
              <h3 className="text-xl font-bold text-brand-gold mb-2">Telefon</h3>
              <a 
                href="tel:+4790801617" 
                className="text-white hover:text-brand-lightGold transition-colors"
              >
                +47 908 01 617
              </a>
            </CardContent>
          </Card>

          <Card className="bg-brand-charcoal/90 border-brand-gold/30 md:col-span-2 lg:col-span-1">
            <CardContent className="p-6 flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-full bg-brand-gold/20 flex items-center justify-center mb-4">
                <MapPin className="w-8 h-8 text-brand-gold" />
              </div>
              <h3 className="text-xl font-bold text-brand-gold mb-2">Adresse</h3>
              <p className="text-white">
                Førde, Norge
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground">
            Vi svarer vanligvis innen 24 timer på hverdager.
          </p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Contact;
